<script lang="ts">
import EventEditor from "@/Components/EventEditor.vue";
import Authenticated from "@/Layouts/AuthenticatedSchool.vue";
import { Event, EventTypes } from "@/Types/event";
import axios from "axios";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "EditEventVue",
    components: { EventEditor },
    layout: Authenticated,
    props: {
        event: {
            type: Object as PropType<Event>,
            required: true,
        },
        eventTypes: {
            type: Array as PropType<EventTypes>,
            required: true,
        },
    },
    methods: {
        submit(data: Event, clbk: () => void, preserveState: boolean, copy: boolean): void {
            if (copy) {
                axios
                    .post(route("school.events.store"), data)
                    .then(() => {
                        if (!preserveState) this.$inertia.visit(route("school.dashboard"), { preserveState: false });
                    })
                    .finally(() => {
                        if (clbk) clbk();
                    });
            } else {
                axios
                    .post(route("school.events.update", { event: this.event.id }), { ...data, _method: "PUT" })
                    .then(() => {
                        if (!preserveState) this.$inertia.visit(route("school.dashboard"), { preserveState: false });
                    })
                    .finally(() => {
                        if (clbk) clbk();
                    });
            }
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('acp.event_edit')" :gap="true">
        <EventEditor :event-types="eventTypes" :event="event" :emit-actions="true" @submit="submit" />
    </MainPage>
</template>
